<template>
    <div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.quotationSubmission)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
                    <b>{{tender.name}}</b>
				</md-card-content>
			</md-card>
		</div>
        <div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded && submissionList.length == 0">
            <md-card>
				<md-card-content class="text-center">
                    {{translate(locale.notApplicationAvailable)}}
				</md-card-content>
			</md-card>
        </div>

        <div class="md-layout-item md-medium-size-100 md-size-100" v-for="(submission, index) in submissionList">
            <md-card>
				<md-card-content>
                    <div class="profile-info" style="text-align: left; display: flex; align-items: center;margin-bottom: 12px;">
                        <div class="profile-image"><img :src="config.cdn + 'images/' + submission.image_logo_url" style="width: 50px" ></div>
                        <div class="profile-name" style="margin-left: 12px"><b>{{submission.profile_name}}</b><br>{{translate(config.datelify(submission.created_date))}}</div>
                    </div>
					<div style="width: 100%; white-space: pre-wrap;">
                        <p><b>{{submission.title}}</b></p>
                        <p>{{submission.content}}</p>
                    </div>
                    <div class="attachment-container" style="display: flex;margin-top: 8px;" v-for="attachment in submission.attachment_list" v-if="attachment.url != null">
                        <a :href="'https://cdn.enterprisetechplatform.com/attachments/' + attachment.url" target="_blank"><div class="attachment">{{attachment.name}}</div></a>
                    </div>
				</md-card-content>
			</md-card>
        </div>
	</div>
</template>
<script>

	export default {
		created() {
			this.getSubmission();
			this.getTender();
		},
		data() {
			return {
				loaded: false,
                submissionList: [],
                tender: {
					name: "",
					location_province_id: "",
					tender_category_id: "",
					tender_sub_category_id: "",
					deadline_date: "",
					deadline_timestamp: "",
					status: "",
					attachment: []
				}
			}
		},
		methods: {
            getSubmission(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/profile/tender/get_submission/" + this.$route.params.hash).then(data => {
					this.submissionList = data.body.data
					// console.log(data.body.data)
					this.loaded = true
				})
			},
            getTender() {
                this.$http.get(this.config.api + "/profile/tender/get/" + this.$route.params.hash).then(data => {

                    let tender = data.body.data.tender;

                    this.tender.name = tender.name;
                    this.tender.content = tender.content;
                    this.tender.tender_category_id = tender.tender_category_id;
                    this.tender.location_province_id = tender.location_province_id;
                })
            }
		}
	}
</script>
<style scoped>
	.attachment {
		color: #1aa348; 
		border: 1px solid #1aa348; 
		border-radius: 4px; 
		padding: 4px 8px; 
		cursor: pointer; 
		margin-right: 8px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Quotation/Submission.vue